/* @flow */

import type { Point, Tools } from './Common';
import { GridHeight, SurfaceLineWidth } from './Common';
import GlobalManager from './GlobalManager';
import Surface from './Surface';

export default class Platform extends Surface {
  colorEdge = '#FFFFFF';
  colorFill = '#555555';

  constructor(centerPosition: Point, radians: number, hypotenuse: number) {
    super(centerPosition, radians, hypotenuse);
    GlobalManager.canvas.subscribePlatform(tools => this.draw(tools));
  }
  draw(tools: Tools) {
    const { radians, leftPoint, rightPoint, colorEdge, colorFill } = this;

    // need more height (visually) on sharper inclines
    const rectDepth = GridHeight / 70 + 5 * Math.abs(radians);
    tools.ctx.fillStyle = colorFill;
    tools.ctx.beginPath();
    tools.ctx.moveTo(rightPoint.x, GridHeight - rightPoint.y);
    tools.ctx.lineTo(rightPoint.x, GridHeight - (rightPoint.y - rectDepth));
    tools.ctx.lineTo(leftPoint.x, GridHeight - (leftPoint.y - rectDepth));
    tools.ctx.lineTo(leftPoint.x, GridHeight - leftPoint.y);
    tools.ctx.fill();

    tools.ctx.lineWidth = SurfaceLineWidth;
    tools.ctx.strokeStyle = colorEdge;
    tools.ctx.beginPath();
    tools.ctx.moveTo(leftPoint.x, GridHeight - leftPoint.y);
    tools.ctx.lineTo(rightPoint.x, GridHeight - rightPoint.y);
    tools.ctx.stroke();
  }
}



// WEBPACK FOOTER //
// ./src/Platform.js